import { useGetResolution886ReportDownload } from '@/hooks/v2/resolution-886';
import type { Resolution886ReportResponse } from '@/context/Resolution886Report/types';

interface PDFGenerateParams {
	report: Resolution886ReportResponse;
	organizationId: string;
	companyId: string;
}

interface PDFGenerateParameters {
	organization_id: string;
	company_id: string;
	report_id: string;
	locale: string;
}

export const usePDFGenerate = ({ report, organizationId, companyId }: PDFGenerateParams) => {
	const { isLoading: downloadPDFLoading, mutateAsync: generatePDF } = useGetResolution886ReportDownload();

	async function handleDownloadPDF(): Promise<void> {
		const parameters: PDFGenerateParameters = {
			organization_id: organizationId,
			company_id: companyId,
			report_id: report?.id,
			locale: window.navigator.language
		};

		await generatePDF(parameters);
	}

	return {
		onDownloadPDF: handleDownloadPDF,
		downloadPDFLoading
	};
};
